import React, { Component } from 'react';
import strings from '../locales/';
/* Components */
import LoadingModal from '../common/loadingModal';
import { localStoreFN } from '../../store/localStorage';

class ModalEdit extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const lang = localStoreFN().getItem('lang');

    return (
      <div
        data-close="ok"
        onClick={this.props.handleModal}
        className={this.props.modal ? `container-modal` : `container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>{this.props.language.account.geozone.modalEdit.edit}</h2>
          {this.props.statusSave == 500 &&
            this.props.dataSave.error.params.map((item, i) => (
              <p key={i} className="error">
                {this.props.language.error[`cod${item.messageCode}`]}{' '}
              </p>
            ))}
          <a>
            <i data-close="ok" onClick={this.props.handleModal} className="fas fa-times-circle" />
          </a>
        </section>
        {this.props.statusSave != 200 && (
          <div className={`box-modal max500`}>
            <section id="modal-edit" className="base-form">
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.geozone.modalEdit.name} <strong>(*)</strong>
                  </label>
                </div>
                <div>
                  <input type="hidden" defaultValue={this.props.config.id} id="id" />
                  <input type="hidden" defaultValue={this.props.config.polygon} id="polygon" />
                  <input
                    data-update="name"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.name}
                    type="text"
                    id="nameup"
                    className="modal-input"
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.geozone.modalEdit.features}{' '}
                    <p> {this.props.language.account.geozone.modalEdit.featureText}</p>
                  </label>
                </div>
                <div>
                  <ul className="multiple-select big">
                    {this.props.characteristic.map((item, i) => {
                      const index = this.props.config.ch
                        .map(function(e) {
                          return e.name;
                        })
                        .indexOf(item.name);
                      if (index >= 0) {
                        return (
                          <li
                            className={
                              this.props.config.ch[index].state
                                ? `square select ${item.name}`
                                : `square ${item.name}`
                            }
                            onClick={this.props.handleSelect}
                            data-chup={`ch-${i}`}
                            data-parent={`ch-${i}`}
                            id={`ch-${i}`}
                            key={`rol-${i}`}
                            data-value={item.name}
                          >
                            {this.props.language.account.geozone[item.name]}
                            <span className="help">
                              <i className="fas fa-question-circle" />{' '}
                              <div className="help-wrapper">
                                {'  '}
                                {this.props.language.account.geozone.modalEdit.baseText[item.name]}
                                {'  '}
                                <span className={`img ${item.name} ${lang}`} />{' '}
                              </div>
                            </span>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {this.props.language.account.geozone.modalEdit.code} <strong>(*)</strong>{' '}
                    <span className="help">
                      <i className="fas fa-question-circle" />
                      <div>{this.props.language.account.geozone.modalEdit.codeText}</div>
                    </span>
                  </label>
                </div>
                <div>
                  <input
                    data-update="code"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.config.code}
                    type="text"
                    id="codeup"
                    className="modal-input"
                  />
                </div>
              </div>
            </section>
          </div>
        )}
        {this.props.statusSave != 200 && (
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {this.props.loadingSave ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> {this.props.language.account.others.loading}
                </div>
              ) : (
                <input
                  className="active"
                  onClick={this.props.handleSubmit}
                  type="button"
                  value={this.props.language.account.geozone.modalEdit.buttonEdit}
                />
              )}
            </div>
          </div>
        )}
        {this.props.statusSave == 200 && (
          <div className={`box-modal max500`}>
            <section className="feed-back green">
              <div>
                <i className="fas fa-check-circle" />
              </div>
              <div>
                <p>{this.props.language.account.geozone.modalEdit.editSucces}</p>
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default ModalEdit;



// WEBPACK FOOTER //
// ./source/client/components/account_geozone/modalEdit.jsx